// A journey token shared by its carousel and PDP history entries, not product data.
export const HISTORY_KEY = 'smartProductJourney';
export const RESTORE_KEY = 'smartProductJourneyRestore';

export const DURATION = 320;

export const EASING = 'cubic-bezier(0.22, 1, 0.36, 1)';
